import cookie from 'js-cookie';
import queryString from 'query-string';

import { STATS_EVENTS, STATS_EVENTS_PARAMS } from '../@types/stats';
import metrika from '../api/stats';

export { STATS_EVENTS };

let mosId;
const getMosId = () => {
  const MOS_ID_COOKIE_NAME = 'mos_id';
  if (!mosId) {
    mosId = cookie.get(MOS_ID_COOKIE_NAME);
  }
  return mosId;
};

const getSearchParam = (key: string) => {
  const { search } = window.location;
  const searchParam = queryString.parse(search)[key];
  return searchParam ?? '';
};

const STATS_VALUES: {
  [key in STATS_EVENTS]: (...params: STATS_EVENTS_PARAMS[key]) => StatsEventData;
} = {
  [STATS_EVENTS.VIEW]: () => ({
    'Отключение воды': 'Просмотр',
  }),
  [STATS_EVENTS.FOCUS]: () => ({
    'Отключение воды': {
      'Адрес': 'Начало ввода',
    },
  }),
  [STATS_EVENTS.ADDRESS_SELECT]: (address) => ({
    'Отключение воды': {
      'Адрес': {
        'Полный адрес': address,
      },
    },
  }),
  [STATS_EVENTS.CALENDAR]: () => ({
    'Отключение воды': {
      'Результат': 'Календарь',
    },
  }),
  [STATS_EVENTS.HAS_HOT_WATER]: () => ({
    'Отключение воды': {
      'Результат': 'Не отключают',
    },
  }),
  [STATS_EVENTS.OUTAGE_PASSED]: () => ({
    'Отключение воды': {
      'Результат': 'Отключение уже было',
    },
  }),
  [STATS_EVENTS.EMPTY_OUTAGE_INFO]: () => ({
    'Отключение воды': {
      'Результат': 'Нет информации об отключении',
    },
  }),
  [STATS_EVENTS.LINK_CLICK]: (link) => ({
    'Отключение воды': {
      'Ссылки': link,
    },
  }),
  [STATS_EVENTS.ERROR_MODAL]: (action) => ({
    'Отключение воды': {
      'Ошибка загрузки адресов': action,
    },
  }),
  [STATS_EVENTS.GET_ADDRESS_REQUEST_TIME]: (time) => ({
    'Отключение воды': {
      'Результат': {
        'Показ': time,
      },
    },
  }),
  [STATS_EVENTS.ADDRESS]: (address) => ({
    address,
    muid: getSearchParam('muid'),
    category: getSearchParam('category'),
    mosid: getMosId(),
    utm: getSearchParam('utm_source'),
  }),
};

export const sendStats = <T extends STATS_EVENTS>(
  eventType: T,
  ...params: STATS_EVENTS_PARAMS[T]
) => {
  const eventObject = STATS_VALUES[eventType](...params);
  try {
    metrika.sendStats(eventObject);
    // eslint-disable-next-line no-empty
  } catch (ignore) {}
};
